export default "__VITE_ASSET__z$D0tJzA__"